module.exports = __webpack_public_path__ + "img/background-sunset.cae9fa04.png";